import { TooltipProvider } from "@/components/ui/tooltip";
import { Dashboard } from "@/components/Dashboard";
import "./index.css";

export function App() {
	return (
		<TooltipProvider>
			<div className="min-h-screen bg-background">
				<div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
					<Dashboard />
				</div>
			</div>
		</TooltipProvider>
	);
}

export default App;
